import React from "react";
import Label from "./Label";
import { ErrorText } from "./ErrorText";

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, ...attributes }, ref) => {
    return (
      <textarea
        ref={ref}
        className={`block w-full px-3 py-2.5 border border-gray-900 bg-transparent rounded focus:outline-none focus:ring-1 focus:ring-secondary focus:border-secondary placeholder:text-gray-200 ${className || ""}`}
        {...attributes}
      />
    );
  }
);

TextArea.displayName = "TextArea";

export default TextArea;




interface TextAreaFieldProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  id: string;
  className?: string;
  error?: any;
  register?: any;
  labelClassName?: string;
  textAreaClassName?: string;
  errorClassName?: string;
  disabled?: boolean
}


export function TextAreaField({
  label,
  id,
  className = "",
  error,
  register,
  labelClassName = "",
  textAreaClassName = "",
  errorClassName = "",
  disabled,
  ...attributes
}: TextAreaFieldProps) {
  return (
    <div className={`flex flex-col ${className || ""}`}>
      <TextArea 
        id={id}
        disabled={disabled}
        className={`peer ${label ? "mt-1" : ""} ${textAreaClassName || ""}`}
        {...attributes}
        {...register}
      >
      </TextArea>
      { label &&
        <Label className={`order-first block ${labelClassName || ""}`} htmlFor={id}>{label}</Label>
      }
      {error && (
        <ErrorText className={`mt-1 ${errorClassName ?? ""}`}>
          {error.message}
        </ErrorText>
      )}
    </div>
  )
}
